import React from 'react';
import VoiceCallingBanners from '../VoiceCallingBanners/index.jsx';
import { useBottomNotificationContext } from '../BottomNotification/bottomNotificationContext';
import { useBannerContext } from './BannerRenderer';

const BannerTypes = Object.freeze({
  voiceCall: 'voiceCall',
});

const getBanner = type => {
  switch (type) {
    case BannerTypes.voiceCall:
      return <VoiceCallingBanners />;
    default:
      throw new Error(`Unknown banner type: ${type}`);
  }
};

const BannerControl = () => {
  const ctx = useBannerContext();
  if (!ctx.type) return null;

  const Comp = getBanner(ctx.type);

  return React.cloneElement(Comp, {
    open: ctx.open,
    close: ctx.reset,
    ...ctx.opts,
  });
};

const noop = () => {};

function useBanner() {
  const { setShowBanner } = useBannerContext();

  const canShowBanner = useBottomNotificationContext();
  if (canShowBanner === false) return noop;

  return setShowBanner;
}

export default BannerControl;
export { BannerTypes, useBanner };
